import { BtnGroup } from "@client";
import { Style } from "@client/style";
import { css, cx } from "@emotion/css";
import { Npc } from "@npc";
import { Drawer, List } from "antd";
import { EventEmitter } from "events";
import React, { ReactNode, useEffect, useState } from "react";
import TypedEmitter from "typed-emitter";
export const MsgEventBus = new EventEmitter() as TypedEmitter<{
  newMsg: (msg: ReactNode) => void;
}>;
export function MsgHistory() {
  const [visible, setVisible] = useState(false);
  const [msgList, setMsgList] = useState([]);
  useEffect(() => {
    MsgEventBus.on("newMsg", (newMsg) => setMsgList((msgList) => [...msgList, newMsg]));
  }, []);
  useEffect(() => {
    Npc.setVisible(visible);
  }, [visible]);
  return (
    <>
      <button
        className={cx(
          Style.btnPrimarySm,
          css`
            position: fixed;
            top: 30vh;
            right: 0;
            width: 3rem;
            z-index: 1000;
            word-break: break-all;
            min-width: 2rem;
            height: 10rem;
            border-radius: 0.2rem 0 0 0.2rem;
            font-size: 1.4rem;
          `
        )}
        onClick={() => setVisible(!visible)}
      >
        消息记录
      </button>
      <Drawer
        title="消息记录"
        placement="right"
        width="35vw"
        closeIcon={false}
        onClose={() => setVisible(false)}
        visible={visible}
      >
        <List
          dataSource={msgList}
          renderItem={(s) => (
            <List.Item>
              <p>{s}</p>
            </List.Item>
          )}
        />
        <BtnGroup>
          <button className={Style.btnPrimarySm} onClick={() => setVisible(false)}>
            收起
          </button>
        </BtnGroup>
      </Drawer>
    </>
  );
}
